export default function PHP_reference_checkdate() {
  return (
    <div>
      <h1>PHP_reference_checkdate</h1>
    </div>
  );
}
